import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { IconRegularHeart } from '@notino/react-styleguide';

import { LOGIN_URL } from '@constants';

import messages from './messages';
import {
  StyledEmptyInfo,
  StyledHeader,
  StyledHeaderText,
  StyledLoginInfoText,
} from './styled';

interface IProps {
  isEmpty: boolean;
  showLoginText?: boolean;
  isShared: boolean;
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export const WishlistHeader = ({
  isEmpty,
  showLoginText,
  isShared,
}: IProps) => {
  const getHeaderText = () => {
    if (isEmpty) return messages.noProducts;
    if (isShared) return messages.sharedProducts;
    return messages.yourProducts;
  };

  return (
    <StyledHeader>
      <StyledHeaderText>
        <FormattedMessage {...getHeaderText()}>
          {(text) => <span dangerouslySetInnerHTML={{ __html: text as any }} />}
        </FormattedMessage>
      </StyledHeaderText>
      {isEmpty && (
        <>
          <StyledEmptyInfo>
            <FormattedMessage {...messages.emptyGuide} />
          </StyledEmptyInfo>

          <StyledEmptyInfo>
            <IconRegularHeart color="icon.primary" />
          </StyledEmptyInfo>
        </>
      )}
      {showLoginText ? (
        <StyledLoginInfoText>
          <FormattedMessage
            {...messages.notLogged}
            values={{
              a: (parts) => <a href={LOGIN_URL}>{parts}</a>,
            }}
          >
            {(text) => (
              <div dangerouslySetInnerHTML={{ __html: text as any }} />
            )}
          </FormattedMessage>
        </StyledLoginInfoText>
      ) : null}
    </StyledHeader>
  );
};
